/*eslint-disable*/
import api from '../'

class ShutterRussianLanguageApi {
    // get: /words-field/groups
    static getGroups (locale) {
        return api.axios.get('/shutter-russian-language/groups', {
            params: {
                locale
            }
        }).then(response => response.data);
    }

    static getItems (params) {
        return api.axios.get('/shutter-russian-language/items', {
            params
        }).then(response => response.data.items);
    }

    static checkIfEnoughWords(params) {
        return api.axios.get('/shutter-russian-language/check-if-enough-words', {
            params
        }).then(response => response.data);
    }
}

export default ShutterRussianLanguageApi;